import React from 'react';

import { DispatcherDropZone } from './dispatcher_drop_zone';
import { DispatcherOrderPreview } from './dispatcher_order_preview';
import { DispatcherStaffingSummary } from './dispatcher_staffing_summary';
import { DispatcherLayout, DispatcherOrderRecord } from './dispatcher_types';

type DispatcherUndispatchedDrawerProps = {
  layout: DispatcherLayout;
  mode?: 'viewing' | 'modifying';
  onDrop?: () => void;
  onDragstart?: (order: DispatcherOrderRecord) => void;
  onDragmove?: (order: DispatcherOrderRecord, event: DragEvent) => void;
  onDragend?: (order: DispatcherOrderRecord) => void;
};

const moverSectionLabel = (count: number) => (count === 1 ? '1 Mover' : `${count} Movers`);

export const DispatcherUndispatchedDrawer: React.FC<DispatcherUndispatchedDrawerProps> = ({
  layout,
  mode = 'viewing',
  onDrop,
  onDragstart,
  onDragmove,
  onDragend,
}) => {
  const { undispatched, staffing } = layout;
  const dropEnabled = mode === 'modifying';

  return (
    <div className="dispatcher-side">
      <DispatcherDropZone enabled={dropEnabled} onDrop={() => onDrop?.()} className="dispatcher-drawer">
        <div className="dispatcher-metadata">
          <DispatcherStaffingSummary staffing={staffing} />
          <br />
          <div className="dispatcher-title">
            <div>Undispatched Orders: {undispatched.orders.length}</div>
          </div>
        </div>

        <div className="dispatcher-calendar dispatcher-scroll">
          {undispatched.sectioned.map((group) => (
            <div key={group.section}>
              <div className="dispatcher-section">{moverSectionLabel(group.section)}</div>
              {group.resources.map((order) => (
                <div key={order.id} className="dispatcher-inline">
                  <DispatcherOrderPreview
                    order={order}
                    mode={mode}
                    undispatched
                    onDragstart={onDragstart}
                    onDragmove={onDragmove}
                    onDragend={onDragend}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      </DispatcherDropZone>
    </div>
  );
};
